import React from "react";
import Navigation from "./navigation/Navigation";

const App = () => {
  return <Navigation />;
};

export default App;
